import React, { useEffect, useState } from "react";
import { getWithAuth } from "../../../api/api";
import { API_URLS } from "../../../api/apiConfig";
import { useAdminPropertiesListContext } from "../adminPropertiesListContext";
import AutoDismissAlert from "../../../components/autoDismiss";
import ModalNewProperty from "../components/modalNewProperty";

const AdminPropertiesListPage = () => {
  const propertiesListontext = useAdminPropertiesListContext();

  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        console.log("Get Properties");
        const data = await getWithAuth(API_URLS.GET_PROPERTIES);
        setProperties(data.data);
      } catch (error) {
        propertiesListontext.setMessage(
          "Ha ocurrido un error conectando con el servidor"
        );
        propertiesListontext.setAlertType("danger");
        propertiesListontext.openAlertHeader();
        console.error("Error getting categories:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [propertiesListontext]);

  return (
    <>
      <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar">
          <div
            id="kt_app_toolbar_container"
            className="app-container container-fluid d-flex flex-stack"
          >
            <div className="page-title d-flex flex-column justify-content-center me-3 mb-6 mb-lg-0">
              <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center me-3 mb-3 my-0">
                Admin - Propiedades
              </h1>
            </div>
          </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div
            id="kt_app_content_container"
            className="app-container container-fluid"
          >
            {propertiesListontext.showAlertHeader && (
              <div className="">
                <AutoDismissAlert
                  message={propertiesListontext.message}
                  alertType={propertiesListontext.alertType}
                  onClose={propertiesListontext.closeAlertHeader}
                />
              </div>
            )}
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh" }}
              >
                <div
                  className="spinner-grow text-color-verde-wofyrooms"
                  style={{ width: "5rem", height: "5em" }}
                  role="status"
                ></div>
              </div>
            ) : (
              <>
                <div className="card mb-5 mb-xxl-10">
                  <div className="card-header border-0 pt-6">
                    <div className="card-title">
                      <h3>Propiedades</h3>
                    </div>
                    <div className="card-toolbar">
                      <div
                        className="d-flex justify-content-end"
                        data-kt-user-table-toolbar="base"
                      >
                        <button
                          onClick={() =>
                            propertiesListontext.openNewPropertyModal()
                          }
                          className="btn btn-sm btn-primary mx-2"
                        >
                          <i className="icon-in-button-color ki-outline ki-plus"></i>
                          Nueva propiedad
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-body py-10">
                    <div
                      id="kt_table_users_wrapper"
                      className="dataTables_wrapper dt-bootstrap4 no-footer"
                    >
                      <div className="table-responsive">
                        <table
                          className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
                          id="kt_table_users"
                        >
                          <thead>
                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                              <th
                                className="min-w-125px sorting"
                                tabIndex="0"
                                aria-controls="kt_table_users"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="User: activate to sort column ascending"
                              >
                                Nombre
                              </th>
                              <th
                                className="min-w-125px sorting"
                                tabIndex="0"
                                aria-controls="kt_table_users"
                                rowSpan="1"
                                colSpan="1"
                              >
                                Código RoomRaccoon
                              </th>
                            </tr>
                          </thead>
                          <tbody className="text-gray-600 fw-semibold">
                            {properties.map((property, index) => (
                              <tr key={index}>
                                <td>{property.name}</td>
                                <td>{property.rr_code}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"></div>
                        <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="kt_table_users_paginate"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {propertiesListontext.showNewPropertyModal && (
        <ModalNewProperty
          onClose={() => propertiesListontext.closeNewPropertyModal()}
        />
      )}
    </>
  );
};

export default AdminPropertiesListPage;
